// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as GemSubgraphExtended } from '../../../../../ui-v3/src/assets/icons/extended/entities/gem-subgraph.svg?react';
import { createIcons } from '../../Icon';
const GemSubgraphIcon = /* @__PURE__ */ createIcons('GemSubgraph', {
    extended: GemSubgraphExtended
});
GemSubgraphIcon.supportedTypes = [
    'extended'
];
GemSubgraphIcon.category = 'entities';
export default GemSubgraphIcon;
